import router from './router';
import http from './axios';
export {
  router,
  http
};



// WEBPACK FOOTER //
// ./src/config/index.js